import { Injectable } from "@angular/core";
import { IItemConfigSet, IItemConfig } from "../interfaces/iitemconfig";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Injectable()
export class ItemConfigHierachyService {
    private configSet: IItemConfigSet;
    private itemsFlat: IItemConfig[] = [];

    constructor(private readonly store: Store<IAppStore>) {

    }

    /**
     * update the sort order and parentid and create a flatlist
     */
    public updateItemsSortOrder(items: IItemConfig[], parentId: number, onlyParentLevel: boolean): IItemConfig[] {
        this.itemsFlat = [];
        this.updateTreeSortOrder(items, parentId, true, onlyParentLevel);
        return this.itemsFlat;
    }

    /**
     * recursive function to update sort order for config items in tree structure
     */
    private updateTreeSortOrder(items: IItemConfig[],
        parentId: number,
        createFlatList: boolean,
        onlyParentLevel: boolean): void {
        let order: number = 0;
        items.forEach((o: IItemConfig) => {
            order += 1;
            o.sortOrder = order;
            if (o.parentId !== parentId) {
                o.parentId = parentId;
            }
            if (createFlatList) {
                this.itemsFlat.push(o);
            }
            if (!onlyParentLevel) {
                if (o.children.length > 0) {
                    this.updateTreeSortOrder(o.children, o.id, createFlatList, onlyParentLevel);
                }
            }
        });
    }

    /**
     * recursive functions to build up tree structure for config items
     */
    private itemTree(item: IItemConfig): void {
        item.children = this.itemList(item.id);
        item.children.forEach((o: IItemConfig) => { this.itemTree(o); }); // recurse
    }

    private itemList(id: number): IItemConfig[] {
        return this.configSet.itemConfigs.filter((o: IItemConfig) => {
            return o.parentId === id;
        });
    }

    /**
     * find an item in the list by id
     */
    public findById(items: IItemConfig[], id: number): IItemConfig {
        // find the item by id
        let result: IItemConfig = null;
        let i: number = 0;
        if (items) {
            for (i = 0; i < items.length; i++) {
                result = this.findByIdRec(items[i], id);
                if (result != null) {
                    return result;
                }
            }
        }
        return result;
    }

    /**
     * recursive function to find an item in the children by id
     */
    private findByIdRec(item: IItemConfig, id: number): IItemConfig {
        // recursivley go through the list and find the item by id
        let result: IItemConfig = null;
        if (item) {
            if (item.id === id) {
                return item;
            }

            // continue searching
            if (item.children) {
                let i: number = 0;
                for (i = 0; i < item.children.length; i++) {
                    let child: IItemConfig = item.children[i];
                    if (child.id === id) {
                        result = child;
                    } else {
                        result = this.findByIdRec(child, id);
                    }
                    if (result) {
                        return result;
                    }
                }
            }
        }
        return result;
    }

    public findFirstChild(item: IItemConfig): IItemConfig {
        // find the first child item
        let result: IItemConfig = null;
        if (item) {
            if (item.children) {
                if (item.children.length > 0) {
                    result = item.children[0];
                }
            }
        }
        return result;
    }

    /**
     * recursive function to find an element of type "itemconfiglistitem" up the DOM tree
     */
    public findParentElement(e: any): any {
        // find element of type "itemconfiglistitem" up the DOM tree
        const type: string = "itemconfiglistitem";
        if (e) {
            const parent: any = e.parentElement;
            if (parent) {
                if (parent.tagName.toLowerCase() === type) {
                    return parent;
                }
            }
            return this.findParentElement(parent);
        }
        return undefined;
    }

    /**
     * recursive function to find an element of type "itemconfiglistitem" down the DOM tree
     */
    public findChildElement(e: any): any {
        // find element of type "itemconfiglistitem" up the DOM tree
        const type: string = "itemconfiglistitem";
        if (e.tagName.toLowerCase() === type) {
            return e;
        }
        if (e) {
            const child: any = e.firstElementChild;
            if (child) {
                if (child.tagName.toLowerCase() === type) {
                    return child;
                }
            }
            return this.findChildElement(child);
        }
        return undefined;
    }
}